import { useEffect, useState } from 'react'; 
import PageInputObj from './PageInputObjCopy.jsx';
import { Typography } from '@mui/material';

const RebateComponentInput = ({ tag, values, setValues, config, errorList=[{}], portfolioId, showOverride=true, disableEdit=false }) => {
    // initialize state
    const [show, setShow] = useState(true); 

    // useEffect to clear values on config change
    useEffect(() => {
        let temp = {}; 
        for (let i = 0; i < config.length; i++) {
            temp[config[i]['rebatecomponentid']] = null; 
        } 
        setValues(values => values = temp); 
    }, [config]); 

    // useEffect to run on portfolioId change 
    useEffect(() => {
        if (showOverride && portfolioId && portfolioId['additionaldetails'] == '1') {
            setShow(show => show = true); 
        }
        else {
            setShow(show => show = false); 
        }
    }, [portfolioId, showOverride]);

    // render all inputs 
    return ( 
        show ? 
            <div className='m-3'>
                <Typography>
                    {tag}
                </Typography>
                <div className="d-flex gap-3 mt-3">
                    {config.map((el) =>
                <>
                            <div>
                                <PageInputObj tag={el['description']} objKey={el['rebatecomponentid']} obj={values} setObj={setValues} showError={errorList[el['rebatecomponentid']]} disableEdit={disableEdit} />
                        </div> 
                </>
                )}

                </div>
            </div>
            : <></>

    ); 
}

export default RebateComponentInput; 